import React, { useState } from 'react';
import { Card, Typography, Avatar, IconButton, Box, Tooltip } from '@mui/material';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import './ServiceTags.scss';

const ServiceTags = ({ tags }) => {
    const [expandedCards, setExpandedCards] = useState(new Set());

    const toggleCardExpansion = (cardIndex) => {
        const newExpandedCards = new Set(expandedCards);
        if (newExpandedCards.has(cardIndex)) {
            newExpandedCards.delete(cardIndex);
        } else {
            newExpandedCards.add(cardIndex);
        }
        setExpandedCards(newExpandedCards);
    };

    const handleCopyEmail = async (email) => {
        try {
            await navigator.clipboard.writeText(email);
            // You could add a toast notification here
            console.log('Email copied to clipboard:', email);
        } catch (err) {
            console.error('Failed to copy email:', err);
            // Fallback for older browsers
            const textArea = document.createElement('textarea');
            textArea.value = email;
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            try {
                document.execCommand('copy');
                console.log('Email copied to clipboard (fallback):', email);
            } catch (fallbackErr) {
                console.error('Fallback copy failed:', fallbackErr);
            }
            document.body.removeChild(textArea);
        }
    };

    const handleEmailClick = (email) => {
        window.location.href = `mailto:${email}`;
    };

    return (
        <div className="custom-card service-tags-container">
            <Typography className="service-tags-title">
                EY Service Tags
            </Typography>
            <div className="row">
                       {(!tags || tags.length === 0) ? (
                    <div className="not-available-service-tags">
                        Not available
                    </div>
                        ) : (
                tags.map((tag, tIndex) => {
                    const isExpanded = expandedCards.has(tIndex);
                    const primaryContact = tag.people[0];
                    const additionalContacts = tag.people.slice(1);
                    const hasMultipleContacts = tag.people.length > 1;

                    return (
                        <Card className="service-tag-card" key={tIndex}>
                            <Typography variant="body2" className="service-tag-title">
                                {tag.title}
                            </Typography>
                            
                            {/* Primary Contact */}
                            {primaryContact && (
                                <Box className="person-info">
                                    <Avatar className="person-avatar">
                                        {primaryContact.name?.charAt(0) || primaryContact.mail?.charAt(0)}
                                    </Avatar>

                                    <div className="person-details">
                                        <Typography variant="caption" className="person-mail">
                                            {primaryContact.mail}
                                        </Typography>
                                        <Typography variant="caption" className="person-name">
                                            {primaryContact.name}
                                        </Typography>
                                    </div>

                                    <IconButton 
                                        size="small" 
                                        className="icon-button" 
                                        title="Copy email"
                                        onClick={() => handleCopyEmail(primaryContact.mail)}
                                    >
                                        <ContentCopyIcon fontSize="small" />
                                    </IconButton>
                                    <IconButton 
                                        size="small" 
                                        className="icon-button" 
                                        title="Email"
                                        onClick={() => handleEmailClick(primaryContact.mail)}
                                    >
                                        <MailOutlineIcon fontSize="small" />
                                    </IconButton>
                                </Box>
                            )}

                            {/* Additional Contacts Indicator */}
                            {hasMultipleContacts && (
                                <Box className={`additional-contacts-section ${isExpanded ? 'expanded' : ''}`}>
                                    {!isExpanded && (
                                        <Box className="contact-initials">
                                            {additionalContacts.slice(0, 3).map((person, index) => (
                                                <Tooltip key={index} title={`${person.name || person.mail}`}>
                                                    <Avatar className="contact-initial-avatar">
                                                        {person.name?.charAt(0) || person.mail?.charAt(0)}
                                                    </Avatar>
                                                </Tooltip>
                                            ))}
                                            {additionalContacts.length > 3 && (
                                                <Typography variant="caption" className="more-contacts-text">
                                                    +{additionalContacts.length - 3}
                                                </Typography>
                                            )}
                                        </Box>
                                    )}
                                    <Tooltip title={isExpanded ? "Show less" : `View ${additionalContacts.length} more contact${additionalContacts.length > 1 ? 's' : ''}`}>
                                        <IconButton 
                                            size="small" 
                                            className="expand-button"
                                            onClick={() => toggleCardExpansion(tIndex)}
                                        >
                                            {isExpanded ? (
                                                <KeyboardArrowUpIcon fontSize="small" />
                                            ) : (
                                                <KeyboardArrowDownIcon fontSize="small" />
                                            )}
                                        </IconButton>
                                    </Tooltip>
                                </Box>
                            )}                            {/* Expanded Additional Contacts */}
                            {isExpanded && additionalContacts.map((person, pIndex) => (
                                <Box className="person-info additional-contact" key={`additional-${pIndex}`}>
                                    <Avatar className="person-avatar">
                                        {person.name?.charAt(0) || person.mail?.charAt(0)}
                                    </Avatar>

                                    <div className="person-details">
                                        <Typography variant="caption" className="person-mail">
                                            {person.mail}
                                        </Typography>
                                        <Typography variant="caption" className="person-name">
                                            {person.name}
                                        </Typography>
                                    </div>

                                    <IconButton 
                                        size="small" 
                                        className="icon-button" 
                                        title="Copy email"
                                        onClick={() => handleCopyEmail(person.mail)}
                                    >
                                        <ContentCopyIcon fontSize="small" />
                                    </IconButton>
                                    <IconButton 
                                        size="small" 
                                        className="icon-button" 
                                        title="Email"
                                        onClick={() => handleEmailClick(person.mail)}
                                    >
                                        <MailOutlineIcon fontSize="small" />
                                    </IconButton>
                                </Box>
                            ))}
                        </Card>
                    );
                  })
                )}
            </div>
        </div>
    );
};

export default ServiceTags;
